function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import base64 from "base-64";
import nanoid from "./nanoid";
import { WebSocket } from "./websocket";
export var DEFAULT_PORTAL_SCALE_FACTOR = 2;
export var SignalType;
(function(SignalType) {
    SignalType[SignalType["Heartbeat"] = 0] = "Heartbeat";
    SignalType[SignalType["Init"] = 1] = "Init";
    SignalType[SignalType["Auth"] = 2] = "Auth";
    SignalType[SignalType["AuthSuccess"] = 3] = "AuthSuccess";
    SignalType[SignalType["AuthFail"] = 4] = "AuthFail";
    SignalType[SignalType["AuthPortal"] = 5] = "AuthPortal";
    SignalType[SignalType["AuthInvalid"] = 6] = "AuthInvalid";
    SignalType[SignalType["AuthUsernameInvalid"] = 7] = "AuthUsernameInvalid";
    SignalType[SignalType["AuthPasswordInvalid"] = 8] = "AuthPasswordInvalid";
    SignalType[SignalType["AuthPortalTimeout"] = 9] = "AuthPortalTimeout";
    SignalType[SignalType["Subscription"] = 10] = "Subscription";
    SignalType[SignalType["Unauthorized"] = 11] = "Unauthorized";
    SignalType[SignalType["SubscriptionFail"] = 12] = "SubscriptionFail";
    SignalType[SignalType["InFlightStatus"] = 13] = "InFlightStatus";
    SignalType[SignalType["KeyboardShow"] = 14] = "KeyboardShow";
    SignalType[SignalType["KeyboardHide"] = 15] = "KeyboardHide";
    SignalType[SignalType["ClipboardPaste"] = 16] = "ClipboardPaste";
    SignalType[SignalType["KeyboardInput"] = 17] = "KeyboardInput";
    SignalType[SignalType["AbortConnection"] = 18] = "AbortConnection";
    SignalType[SignalType["AuthPlatformError"] = 19] = "AuthPlatformError";
    SignalType[SignalType["AuthPasswordReset"] = 20] = "AuthPasswordReset";
})(SignalType || (SignalType = {}));
export var InFlightState;
(function(InFlightState) {
    InFlightState[InFlightState["Authenticating"] = 1] = "Authenticating";
    InFlightState[InFlightState["Portal"] = 2] = "Portal";
    InFlightState[InFlightState["SubParsing"] = 3] = "SubParsing";
})(InFlightState || (InFlightState = {}));
export var Client = /*#__PURE__*/ function() {
    "use strict";
    function Client(config) {
        var _this = this;
        _classCallCheck(this, Client);
        this._handleMessage = function(event) {
            var _obj, ref;
            var s = JSON.parse(event.data);
            (ref = (_obj = _this)._onSignal) === null || ref === void 0 ? void 0 : ref.call(_obj, s);
            switch(s.type){
                case SignalType.Init:
                    var ref1;
                    (ref1 = _this._handler) === null || ref1 === void 0 ? void 0 : ref1.onInit(s);
                    break;
                case SignalType.AuthSuccess:
                    var ref2;
                    (ref2 = _this._handler) === null || ref2 === void 0 ? void 0 : ref2.onAuthSuccess(s);
                    break;
                case SignalType.AuthPortal:
                    var ref3;
                    (ref3 = _this._handler) === null || ref3 === void 0 ? void 0 : ref3.onAuthPortal(s);
                    break;
                case SignalType.AuthPortalTimeout:
                    var ref4;
                    (ref4 = _this._handler) === null || ref4 === void 0 ? void 0 : ref4.onAuthPortalTimeout(s);
                    break;
                case SignalType.AuthPlatformError:
                    var ref5;
                    (ref5 = _this._handler) === null || ref5 === void 0 ? void 0 : ref5.onAuthPlatformError(s);
                    break;
                case SignalType.AuthFail:
                    var ref6;
                    (ref6 = _this._handler) === null || ref6 === void 0 ? void 0 : ref6.onAuthFail(s);
                    break;
                case SignalType.AuthUsernameInvalid:
                    var ref7;
                    (ref7 = _this._handler) === null || ref7 === void 0 ? void 0 : ref7.onAuthUsernameInvalid(s);
                    break;
                case SignalType.AuthPasswordInvalid:
                    var ref8;
                    (ref8 = _this._handler) === null || ref8 === void 0 ? void 0 : ref8.onAuthPasswordInvalid(s);
                    break;
                case SignalType.AuthInvalid:
                    var ref9;
                    (ref9 = _this._handler) === null || ref9 === void 0 ? void 0 : ref9.onAuthInvalid(s);
                    break;
                case SignalType.Unauthorized:
                    var ref10;
                    (ref10 = _this._handler) === null || ref10 === void 0 ? void 0 : ref10.onUnauthorized(s);
                    break;
                case SignalType.Subscription:
                    var ref11;
                    (ref11 = _this._handler) === null || ref11 === void 0 ? void 0 : ref11.onSubscription(s);
                    break;
                case SignalType.SubscriptionFail:
                    var ref12;
                    (ref12 = _this._handler) === null || ref12 === void 0 ? void 0 : ref12.onSubscriptionFail(s);
                    break;
                case SignalType.InFlightStatus:
                    var ref13;
                    (ref13 = _this._handler) === null || ref13 === void 0 ? void 0 : ref13.onInFlightStatus(s);
                    break;
                case SignalType.KeyboardShow:
                    var ref14;
                    (ref14 = _this._handler) === null || ref14 === void 0 ? void 0 : ref14.onKeyboardShow(s);
                    break;
                case SignalType.KeyboardHide:
                    var ref15;
                    (ref15 = _this._handler) === null || ref15 === void 0 ? void 0 : ref15.onKeyboardHide(s);
                    break;
                case SignalType.AuthPasswordReset:
                    var ref16;
                    (ref16 = _this._handler) === null || ref16 === void 0 ? void 0 : ref16.onAuthPasswordReset(s);
                    break;
                default:
            }
        };
        this._handleOpen = function(reconnect) {
            var _obj, ref, ref17, ref18;
            (ref = (_obj = _this)._onOpen) === null || ref === void 0 ? void 0 : ref.call(_obj, reconnect);
            (ref17 = _this._handler) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.onopen) === null || ref18 === void 0 ? void 0 : ref18.call(ref17, reconnect);
        };
        this._handleDisconnect = function(retrying) {
            var _obj, ref, ref19;
            (ref = (_obj = _this)._onDisconnect) === null || ref === void 0 ? void 0 : ref.call(_obj, retrying);
            (ref19 = _this._handler) === null || ref19 === void 0 ? void 0 : ref19.ondisconnect(retrying);
        };
        var wsURI = config.wsURI, handler = config.handler, onSignal = config.onSignal, onOpen = config.onOpen, onDisconnect = config.onDisconnect;
        this._id = nanoid();
        this._handler = handler;
        this._onSignal = onSignal;
        this._onOpen = onOpen;
        this._onDisconnect = onDisconnect;
        var params = {
            id: this._id,
            viewport: config.viewport,
            connectionID: config.connectionID,
            roomID: config.roomID,
            browserStr: config.browserStr,
            osStr: config.osStr,
            deviceTypeStr: config.deviceTypeStr
        };
        this._connectionID = config.connectionID;
        var jsonParams = JSON.stringify(params);
        var b64EncodedParams = base64.encode(jsonParams);
        var wsQS = "?params=".concat(b64EncodedParams);
        var accessToken = "";
        if (config.accessToken) {
            accessToken = config.accessToken;
        }
        var heartbeatSignal = {
            type: SignalType.Heartbeat
        };
        this._ws = new WebSocket("".concat(wsURI).concat(wsQS), accessToken, heartbeatSignal);
        this._addSignalListeners();
    }
    var _proto = Client.prototype;
    _proto._addSignalListeners = function _addSignalListeners() {
        this._ws.onopen = this._handleOpen;
        this._ws.ondisconnect = this._handleDisconnect;
        this._ws.addMessageListener(this._handleMessage);
    };
    _proto.auth = function auth(userID, username, password, platform) {
        var s = {
            type: SignalType.Auth,
            userID: userID,
            platform: platform,
            username: username,
            password: password
        };
        this._ws.send(s);
    };
    _proto.clipboardPaste = function clipboardPaste(text) {
        var s = {
            type: SignalType.ClipboardPaste,
            data: text,
            connectionID: this.connectionID
        };
        this._ws.send(s);
    };
    _proto.keyboardInput = function keyboardInput(key) {
        var s = {
            type: SignalType.KeyboardInput,
            data: key,
            connectionID: this.connectionID
        };
        this._ws.send(s);
    };
    _proto.abort = function abort() {
        var s = {
            type: SignalType.AbortConnection
        };
        this._ws.send(s);
        this.close();
    };
    _proto.close = function close() {
        this._ws.close();
    };
    _createClass(Client, [
        {
            key: "connectionID",
            get: function get() {
                return this._connectionID;
            }
        }
    ]);
    return Client;
}();
